import './sectionInfo.css';

export default function sectionInfo({title, children, image})
{
    return(
        <div className='whoWeAre' id="whoWeAre">
          <div className='column'>
            <img className='image' alt="Blends" src={image}></img>
          </div>
          <div className='column'>
            <h2>{title}</h2>
            <p>
              {children}
            </p>
          </div>
        </div>
    );
}